// ─────────────────────────────────────────────────────────────────────────────
// HeroEditor.tsx — ContentSectionEditPageProduct
// ─────────────────────────────────────────────────────────────────────────────
import React, { useRef } from 'react';
import { HeroSection } from './types';
import { LabelRow, SplitRow, DraftTextField } from './components';

const HeroEditor: React.FC<{
  data:     HeroSection;
  onChange: (v: HeroSection) => void;
}> = ({ data, onChange }) => {
  const orig = useRef(data);

  const set    = (p: Partial<HeroSection>) => onChange({ ...data, ...p });
  const setBtn = (p: Partial<HeroSection['primaryButton']>) =>
    onChange({ ...data, primaryButton: { ...data.primaryButton, ...p } });

  return (
    <>
      <LabelRow label="Main Title" required />
      <SplitRow currentText={orig.current.title}>
        <DraftTextField
          placeholder="Sector title"
          onChange={v => set({ title: v })}
        />
      </SplitRow>

      <LabelRow
        label="Primary button"
        toggle={{
          checked:  data.primaryButton.visible,
          onChange: v => setBtn({ visible: v }),
        }}
      />
      <SplitRow currentText={orig.current.primaryButton.label}>
        <DraftTextField
          placeholder="Text button"
          onChange={v => setBtn({ label: v })}
        />
      </SplitRow>
    </>
  );
};

export default HeroEditor;